import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, CheckCircle2 } from 'lucide-react';
const bonuses = [{
  num: '1',
  title: 'Triángulo de Evaluación Pediátrica Express',
  desc: 'La herramienta de evaluación inicial más usada en guardia, en formato de consulta inmediata.',
  pages: '30 págs',
  image: 'https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=900&h=300&q=70'
}, {
  num: '2',
  title: 'Tablas de Dosis Pediátricas por Peso',
  desc: 'El recurso más buscado en guardia: dosis por kilo de los fármacos más usados.',
  pages: '30 págs',
  image: 'https://images.unsplash.com/photo-1584308666744-24d5c474f2ae?auto=format&fit=crop&w=900&h=300&q=70'
}, {
  num: '3',
  title: 'Checklist de Lactante Febril Menor de 3 Meses',
  desc: 'El caso que más angustia genera, sistematizado en una herramienta de bolsillo.',
  pages: '30 págs',
  image: 'https://images.unsplash.com/photo-1584516150909-c43483ee7932?auto=format&fit=crop&w=900&h=300&q=70'
}, {
  num: '4',
  title: 'Script de Comunicación con Padres en Guardia',
  desc: 'Exactamente qué decir al padre que llega a las 3am exigiendo antibiótico.',
  pages: '30 págs',
  image: 'https://images.unsplash.com/photo-1577896851231-70ef18881754?auto=format&fit=crop&w=900&h=300&q=70'
}, {
  num: '5',
  title: 'Protocolo de Alta Segura en Guardia Pediátrica',
  desc: 'Criterios de alta, documentación y señales de alarma para entregar a los padres.',
  pages: '30 págs',
  image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=900&h=300&q=70'
}, {
  num: '6',
  title: 'Pack de 20 Plantillas de Instagram para Pediatras',
  desc: 'Posicionamiento digital en el nicho de pediatría y guardia.',
  pages: '30 págs',
  image: 'https://images.unsplash.com/photo-1611162617474-5b21e879e113?auto=format&fit=crop&w=900&h=300&q=70'
}];
export function Bonuses() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-8 sm:py-28 relative overflow-hidden" data-id="element-32">
      <div className="absolute top-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-slate-200 to-transparent" data-id="element-33"></div>

      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8" data-id="element-34">
        <div className="text-center max-w-3xl mx-auto mb-5 sm:mb-16" data-id="element-35">
          <h2 className="text-[10px] sm:text-sm font-semibold tracking-wide text-teal-600 uppercase mb-1.5 sm:mb-3" data-id="element-36">
            INCLUIDOS GRATIS
          </h2>
          <p className="text-xl font-bold tracking-tight text-slate-900 sm:text-4xl mb-2 sm:mb-4" data-id="element-37">
            6 Bonos de Guardia
          </p>
          <p className="text-xs sm:text-lg text-slate-600" data-id="element-38">
            Sin costo extra — incluidos en todas las ofertas
          </p>
        </div>

        <div className="space-y-2 sm:space-y-4 mb-5 sm:mb-16" data-id="element-39">
          {bonuses.map((bono, index) => {
          const isOpen = openIndex === index;
          return <motion.div key={index} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.05
          }} className={`rounded-xl sm:rounded-2xl overflow-hidden ring-1 transition-all bg-white ${isOpen ? 'ring-teal-200 shadow-md' : 'ring-slate-200 shadow-sm'}`} data-id="element-40">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="relative block w-full aspect-[3/1] overflow-hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500 group" data-id="element-41">
                  <img src={bono.image} alt={bono.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-42" />
                  <div className="absolute inset-0 bg-gradient-to-r from-slate-900/85 via-slate-900/60 to-slate-900/30" data-id="element-43"></div>
                  <div className="absolute top-0 right-0 bg-teal-500 text-white text-[8px] sm:text-xs font-bold px-1.5 py-0.5 sm:px-3 sm:py-1 rounded-bl-lg uppercase tracking-wider" data-id="element-44">
                    GRATIS
                  </div>
                  <div className="absolute inset-0 flex items-center gap-2 sm:gap-4 px-3 sm:px-6" data-id="element-45">
                    <div className="flex-shrink-0 w-8 h-8 sm:w-12 sm:h-12 rounded-lg sm:rounded-xl bg-white/15 backdrop-blur-sm text-white flex items-center justify-center font-bold text-sm sm:text-xl ring-1 ring-white/30" data-id="element-46">
                      {bono.num}
                    </div>
                    <div className="text-left min-w-0 pr-2" data-id="element-47">
                      <p className="text-[8px] sm:text-xs font-semibold text-teal-300 uppercase tracking-wider" data-id="element-48">
                        Bono {bono.num}
                      </p>
                      <h3 className="text-xs sm:text-lg font-bold text-white leading-snug" data-id="element-49">
                        {bono.title}
                      </h3>
                    </div>
                    <ChevronDown className={`ml-auto flex-shrink-0 w-4 h-4 sm:w-6 sm:h-6 text-white transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-50" />
                  </div>
                </button>

                <AnimatePresence data-id="element-51">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} className="overflow-hidden" data-id="element-52">
                      <div className="px-3 sm:px-6 py-3 sm:py-5" data-id="element-53">
                        <p className="text-[10px] sm:text-base text-slate-600 leading-relaxed mb-2 sm:mb-3" data-id="element-54">
                          {bono.desc}
                        </p>
                        <div className="inline-flex items-center text-[8px] sm:text-xs font-medium text-slate-500 bg-slate-50 px-1.5 py-0.5 sm:px-2 sm:py-1 rounded-md ring-1 ring-slate-200" data-id="element-55">
                          {bono.pages}
                        </div>
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="max-w-2xl mx-auto bg-gradient-to-br from-blue-50 to-teal-50 rounded-xl sm:rounded-2xl p-4 sm:p-8 ring-1 ring-blue-100 text-center" data-id="element-56">
          <p className="text-sm sm:text-xl font-medium text-slate-900 mb-2 sm:mb-4" data-id="element-57">
            Valor Total de los 6 Bonos{' '}
            <span className="line-through text-slate-400" data-id="element-58">$84.000 ARS</span>{' '}
            <span className="text-teal-600 font-bold block sm:inline mt-0.5 sm:mt-0" data-id="element-59">
              → GRATIS
            </span>
          </p>
          <div className="flex items-center justify-center gap-1.5 sm:gap-2 text-blue-800 text-[10px] sm:text-base font-medium" data-id="element-60">
            <CheckCircle2 className="w-3 h-3 sm:w-5 sm:h-5 text-teal-600" data-id="element-61" />
            <span data-id="element-62">Incluidos con cualquier oferta</span>
          </div>
        </motion.div>
      </div>
    </section>;
}